/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/29/21
 * Copyright All Rights Reserved
 */
import React from 'react';
import classNames from 'classnames';
import BasicReduxFormSelectMenu from 'components/support/forms/SelectMenus/BasicReduxFormSelectMenu';
import RenderInput from 'components/support/forms/RenderInput';

const items = [
  {
    id: 'mean',
    name: 'Mean',
    value: 'mean',
  },
  {
    id: 'median',
    name: 'Median',
    value: 'median',
  },
  {
    id: 'p90',
    name: '90th Percentile',
    value: 'p90',
  },
];

const ConfidenceLevelSelectMenu = () => (
  <BasicReduxFormSelectMenu
    includeEmptyOption={false}
    items={items}
    id="confidenceLevel"
    name="confidenceLevel"
    inputClassName={classNames('custom-select', 'confidence-level-select')}
    component={RenderInput}
  />
);

export default ConfidenceLevelSelectMenu;



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/InventoryPageControlForm/ConfidenceLevelSelectMenu/index.jsx